import { type ReactNode } from 'react';
import { Input } from '@/components/ui/input';

export type PersonalForm = {
  first_name: string;
  last_name: string;
  email: string;
  phone_prefix: string;
  phone_number: string;
  country: string;
  city: string;
  birthdate: string;
};

type Props = {
  f: PersonalForm;
  set: (k: keyof PersonalForm, v: string) => void;
};

export function NameRow({ f, set }: Props): ReactNode {
  return (
    <>
      <Input
        label="Nombre"
        value={f.first_name}
        onChange={(e) => set('first_name', e.target.value)}
      />
      <Input
        label="Apellidos"
        value={f.last_name}
        onChange={(e) => set('last_name', e.target.value)}
      />
    </>
  );
}

export function EmailField({ f, set }: Props): ReactNode {
  return (
    <div className="col-span-2">
      <Input
        type="email"
        label="Email"
        value={f.email}
        onChange={(e) => set('email', e.target.value)}
      />
    </div>
  );
}

export function BirthdateField({ f, set }: Props): ReactNode {
  return (
    <div className="col-span-2">
      <Input
        type="date"
        label="Cumpleanos"
        value={f.birthdate}
        onChange={(e) => set('birthdate', e.target.value)}
      />
    </div>
  );
}
